import { CarouselItemViewModel, ComponentType } from '@/types/cml-api';
import { sendCtaClickEvent } from '@/features/analytics/datalayer/datalayer';
import { AppNextLink } from '@/features/app-next-link';
import LazyImage from '@/features/image/lazy-image';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { Webengage } from '@/features/webengage';
import { cn } from '@/utils/cn';
import { DataLayerProps, IsLoadingLazyProps } from '../../type';
interface Props extends IsLoadingLazyProps, DataLayerProps {
  item: CarouselItemViewModel;
  currentSlide: number;
  slideIndex: number;
}
export default function CarouselBigItem({
  item: {
    link,
    desktopImageUrl,
    mobileImageUrl,
    title,
    id
  },
  currentSlide,
  slideIndex,
  isLazy,
  sortKey,
  componentId
}: Props) {
  const {
    isMobile
  } = useMobileDetect();
  const handleClick = () => {
    sendCtaClickEvent({
      elementType: ComponentType.CarouselBig,
      elementIndex: slideIndex || 0,
      itemID: id ?? '',
      elementName: sortKey,
      destinationUrl: link ?? '',
      componentId: componentId ?? '',
      ImageUrl: isMobile ? mobileImageUrl : desktopImageUrl
    });
    Webengage.trackCtaAction({
      banner_type: ComponentType.CarouselBig,
      banner_name: sortKey ?? '',
      banner_index: slideIndex?.toString() || '0',
      url_destination: link || '',
      item_id: id || '',
      component_id: componentId ?? '',
      image_url: (isMobile ? mobileImageUrl : desktopImageUrl) ?? ''
    });
  };
  if (!mobileImageUrl || !title) return null;
  return <AppNextLink onClick={handleClick} key={id || link} href={link || ''} prefetch={false} aria-label={title} className='keen-slider__slide min-w-80 overflow-hidden rounded md:min-w-[992px] lg:min-w-[1200px]' data-sentry-element="AppNextLink" data-sentry-component="CarouselBigItem" data-sentry-source-file="carousel-big-item.tsx">
            <picture data-sentry-element="picture" data-sentry-source-file="carousel-big-item.tsx">
                <source media='(min-width: 992px)' srcSet={desktopImageUrl || ''} />

                <LazyImage src={mobileImageUrl} alt={title} className={cn('w-full scale-y-90 rounded transition-all duration-300', currentSlide === slideIndex && '!scale-100')} loaderClassName='min-h-[300px] lg:min-h-[460px]' isLazy={isLazy} data-sentry-element="LazyImage" data-sentry-source-file="carousel-big-item.tsx" />
            </picture>
        </AppNextLink>;
}